import React from 'react'
import { NoSSR } from '@/components/NoSSR'
import { useModal } from '@/hooks'
import { ModalType } from '@/types/modal'
import ChampionshipCodeBody from './ChampionshipCode'
import ChampionshipsSucceeded from './ChampionshipsSucceeded'
import ChangePasswordBody from './ChangePassword'
import ContestWorkBody from './ContestWork'
import EnterTournamentBody from './EnterTournament'
import Family from './Family'
import FeedbackBody from './Feedback'
import LifehackBody from './Lifehack'
import Modal from './Modal'
import UrbanClubBenefitsBody from './UrbanClubBenefits'
import WorkUploadedBody from './WorkUploaded'
import Image from './Image'

const modals: { [key in ModalType]: React.ReactNode | null } = {
  changePassword: ChangePasswordBody,
  championshipsSucceeded: ChampionshipsSucceeded,
  enterTournament: EnterTournamentBody,
  lifehack: LifehackBody,
  feedback: FeedbackBody,
  championshipCode: ChampionshipCodeBody,
  contestWork: ContestWorkBody,
  image: Image,
  workUploaded: WorkUploadedBody,
  urbanClubBenefits: UrbanClubBenefitsBody,
  empty: (): null => null,
  family: Family
}

const Modals = (): React.ReactElement => {
  const { closeModal, showModal, isOpen } = useModal()
  const CurrentModal = modals[showModal ?? 'empty']

  const afterHideModal = (): void => closeModal()

  const noBodyModalList = ['lifehack', 'contestWork', 'image']
  const full = ['image']
  const wideBodyModalList = ['urbanClubBenefits']

  return (
    <NoSSR>
      <Modal
        handleClose={closeModal}
        open={isOpen || undefined}
        onGx-after-hide={afterHideModal}
        noBody={noBodyModalList.includes(showModal)}
        full={full.includes(showModal)}
        wideBody={wideBodyModalList.includes(showModal)}
        customStyle={showModal}
      >
        <CurrentModal handleClose={closeModal} />
      </Modal>
    </NoSSR>
  )
}

export default Modals
